import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredTreesIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_3310_148)">
            <path
              d="M14.2 19V22"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M13.4 18H21.7C21.8957 17.9973 22.0863 17.9371 22.2482 17.8271C22.4101 17.717 22.5361 17.5618 22.6106 17.3808C22.6852 17.1998 22.7049 17.001 22.6675 16.8088C22.63 16.6167 22.537 16.4398 22.4 16.3L19.4 13H19.7C19.8957 12.9973 20.0863 12.9371 20.2482 12.8271C20.4101 12.717 20.5361 12.5619 20.6106 12.3808C20.6852 12.1998 20.7049 12.001 20.6675 11.8088C20.63 11.6167 20.537 11.4398 20.4 11.3L17.4 8H17.6C17.8043 8.01843 18.0092 7.97361 18.1872 7.87162C18.3651 7.76963 18.5073 7.6154 18.5947 7.42984C18.682 7.24428 18.7101 7.03636 18.6753 6.83425C18.6405 6.63215 18.5444 6.44564 18.4 6.3L14.4 2L13 3.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M5.82395 15.9999C5.38642 15.9743 4.95982 15.8532 4.57415 15.645C4.18849 15.4367 3.85312 15.1466 3.59165 14.7948C3.33018 14.4431 3.14896 14.0383 3.06073 13.609C2.97249 13.1797 2.9794 12.7363 3.08095 12.3099C2.71842 12.008 2.4322 11.6249 2.24554 11.1916C2.05888 10.7583 1.97703 10.2872 2.00665 9.81631C2.03627 9.34547 2.17651 8.88825 2.41599 8.48177C2.65548 8.0753 2.98745 7.73104 3.38495 7.47695C3.03632 6.8576 2.9189 6.1346 3.05361 5.43676C3.18832 4.73891 3.56641 4.11156 4.12051 3.66648C4.67462 3.22139 5.36874 2.98749 6.07922 3.00644C6.78969 3.02539 7.47036 3.29596 7.99995 3.76995C8.52966 3.29671 9.21011 3.02678 9.92018 3.0082C10.6303 2.98962 11.3239 3.22359 11.8776 3.66848C12.4314 4.11336 12.8093 4.7403 12.9441 5.4377C13.0789 6.1351 12.962 6.85772 12.6139 7.47695C13.0115 7.73096 13.3436 8.07515 13.5831 8.48158C13.8227 8.88801 13.9631 9.34521 13.9928 9.81606C14.0225 10.2869 13.9407 10.7581 13.7542 11.1914C13.5676 11.6248 13.2814 12.008 12.9189 12.3099C13.0239 12.7507 13.0277 13.2096 12.9299 13.652C12.8322 14.0945 12.6355 14.5091 12.3546 14.8646C12.0737 15.2202 11.716 15.5075 11.3081 15.705C10.9003 15.9025 10.4531 16.005 9.99995 16.0049H5.99995L5.82395 15.9999Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#006E00"
            />
            <path
              d="M8 13L6 11"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M8 12L10 10"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M8.19995 22V8"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
          </g>
          <defs>
            <clipPath id="clip0_3310_148">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_3310_158)">
            <path
              opacity="0.2"
              d="M5.82322 15.9946C5.38569 15.969 4.95909 15.8478 4.57342 15.6396C4.18775 15.4314 3.85239 15.1412 3.59092 14.7895C3.32945 14.4377 3.14823 14.033 3.05999 13.6037C2.97176 13.1743 2.97866 12.7309 3.08022 12.3046C2.71769 12.0027 2.43147 11.6195 2.24481 11.1863C2.05815 10.753 1.9763 10.2818 2.00592 9.81094C2.03553 9.3401 2.17578 8.88287 2.41526 8.4764C2.65475 8.06993 2.98672 7.72567 3.38422 7.47158C3.03559 6.85223 2.91817 6.12923 3.05288 5.43138C3.18759 4.73354 3.56568 4.10619 4.11978 3.66111C4.67388 3.21602 5.36801 2.98212 6.07848 3.00107C6.78896 3.02002 7.46963 3.29059 7.99922 3.76458C8.52893 3.29134 9.20937 3.02141 9.91945 3.00283C10.6295 2.98425 11.3232 3.21822 11.8769 3.66311C12.4306 4.10799 12.8085 4.73493 12.9434 5.43233C13.0782 6.12973 12.9612 6.85235 12.6132 7.47158C13.0108 7.72559 13.3428 8.06978 13.5824 8.47621C13.822 8.88264 13.9623 9.33984 13.992 9.81069C14.0218 10.2815 13.94 10.7527 13.7534 11.1861C13.5668 11.6194 13.2807 12.0026 12.9182 12.3046C13.0232 12.7454 13.0269 13.2042 12.9292 13.6467C12.8315 14.0891 12.6348 14.5037 12.3539 14.8593C12.073 15.2148 11.7152 15.5021 11.3074 15.6996C10.8996 15.8971 10.4523 15.9997 9.99922 15.9996H5.99922L5.82322 15.9946Z"
              fill="#006E00"
            />
            <path
              d="M14.2 19V22"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M13.4 18H21.7C21.8957 17.9973 22.0863 17.9371 22.2482 17.8271C22.4101 17.717 22.5361 17.5618 22.6106 17.3808C22.6852 17.1998 22.7049 17.001 22.6675 16.8088C22.63 16.6167 22.537 16.4398 22.4 16.3L19.4 13H19.7C19.8957 12.9973 20.0863 12.9371 20.2482 12.8271C20.4101 12.717 20.5361 12.5619 20.6106 12.3808C20.6852 12.1998 20.7049 12.001 20.6675 11.8088C20.63 11.6167 20.537 11.4398 20.4 11.3L17.4 8H17.6C17.8043 8.01843 18.0092 7.97361 18.1872 7.87162C18.3651 7.76963 18.5073 7.6154 18.5947 7.42984C18.682 7.24428 18.7101 7.03636 18.6753 6.83425C18.6405 6.63215 18.5444 6.44564 18.4 6.3L14.4 2L13 3.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M5.82395 15.9999C5.38642 15.9743 4.95982 15.8532 4.57415 15.645C4.18849 15.4367 3.85312 15.1466 3.59165 14.7948C3.33018 14.4431 3.14896 14.0383 3.06073 13.609C2.97249 13.1797 2.9794 12.7363 3.08095 12.3099C2.71842 12.008 2.4322 11.6249 2.24554 11.1916C2.05888 10.7583 1.97703 10.2872 2.00665 9.81631C2.03627 9.34547 2.17651 8.88825 2.41599 8.48177C2.65548 8.0753 2.98745 7.73104 3.38495 7.47695C3.03632 6.8576 2.9189 6.1346 3.05361 5.43676C3.18832 4.73891 3.56641 4.11156 4.12051 3.66648C4.67462 3.22139 5.36874 2.98749 6.07922 3.00644C6.78969 3.02539 7.47036 3.29596 7.99995 3.76995C8.52966 3.29671 9.21011 3.02678 9.92018 3.0082C10.6303 2.98962 11.3239 3.22359 11.8776 3.66848C12.4314 4.11336 12.8093 4.7403 12.9441 5.4377C13.0789 6.1351 12.962 6.85772 12.6139 7.47695C13.0115 7.73096 13.3436 8.07515 13.5831 8.48158C13.8227 8.88801 13.9631 9.34521 13.9928 9.81606C14.0225 10.2869 13.9407 10.7581 13.7542 11.1914C13.5676 11.6248 13.2814 12.008 12.9189 12.3099C13.0239 12.7507 13.0277 13.2096 12.9299 13.652C12.8322 14.0945 12.6355 14.5091 12.3546 14.8646C12.0737 15.2202 11.716 15.5075 11.3081 15.705C10.9003 15.9025 10.4531 16.005 9.99995 16.0049H5.99995L5.82395 15.9999Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#006E00"
              fill="#d2e3d1"
            />
            <path
              d="M8 13L6 11"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#006E00"
            />
            <path
              d="M8 12L10 10"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#006E00"
            />
            <path
              d="M8.19995 22V8"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#006E00"
            />
          </g>
          <defs>
            <clipPath id="clip0_3310_158">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredTreesIcon;
